/* Curlora theme — interactions & animations (vanilla JS, no dependencies) */
(function () {
  'use strict';

  var C = window.Curlora || {};
  var routes = C.routes || { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart', root: '/' };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------------- Money ---------------- */
  /* The shop format is in the store currency (EUR); derive the format of the
     visitor's market currency from a sample rendered with Liquid's money filter. */
  var _fmt;
  function activeFormat() {
    if (_fmt) return _fmt;
    var s = (C.moneySample || '').replace(/[  ]/g, ' ');
    var map = [['1,234.56', 'amount'], ['1.234,56', 'amount_with_comma_separator'], ["1'234.56", 'amount_with_apostrophe_separator'],
      ['1 234,56', 'amount_with_space_separator'], ['1 234.56', 'amount_with_period_and_space_separator'],
      ['1,235', 'amount_no_decimals'], ['1.235', 'amount_no_decimals_with_comma_separator'], ['1 235', 'amount_no_decimals_with_space_separator']];
    for (var i = 0; i < map.length; i++) {
      if (s.indexOf(map[i][0]) > -1) { _fmt = s.replace(map[i][0], '{{' + map[i][1] + '}}'); return _fmt; }
    }
    _fmt = C.moneyFormat || '${{amount}}';
    return _fmt;
  }
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || activeFormat();
    function fmt(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = fmt(cents, 2, ' ', '.'); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' '); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, value).replace(/<[^>]*>/g, '');
  }
  C.formatMoney = formatMoney;

  /* ---------------- Header ---------------- */
  var header = $('.site-header');
  var lastY = window.scrollY;
  function onScrollHeader() {
    if (!header) return;
    var y = window.scrollY;
    header.classList.toggle('is-scrolled', y > 30);
    var drawerOpen = document.documentElement.classList.contains('drawer-open');
    if (!drawerOpen) header.classList.toggle('is-hidden', y > 260 && y > lastY + 4);
    if (y < lastY - 4) header.classList.remove('is-hidden');
    lastY = y;
  }

  /* ---------------- Mobile menu ---------------- */
  var menu = $('[data-mobile-menu]');
  $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { if (menu) { menu.classList.add('is-open'); b.setAttribute('aria-expanded', 'true'); } }); });
  $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { if (menu) menu.classList.remove('is-open'); $$('[data-menu-open]').forEach(function (x) { x.setAttribute('aria-expanded', 'false'); }); }); });
  $$('.mm-link').forEach(function (a) { a.addEventListener('click', function () { if (menu) menu.classList.remove('is-open'); }); });

  /* ---------------- Split text ---------------- */
  $$('[data-split]').forEach(function (el) {
    var i = 0;
    function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (child) {
        if (child.nodeType === 3) {
          var frag = document.createDocumentFragment();
          child.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
            var w = document.createElement('span'); w.className = 'w';
            var inner = document.createElement('span'); inner.textContent = part; inner.style.setProperty('--wi', i++);
            w.appendChild(inner); frag.appendChild(w);
          });
          node.replaceChild(frag, child);
        } else if (child.nodeType === 1 && child.tagName !== 'BR') {
          walk(child);
        }
      });
    }
    walk(el);
  });

  /* ---------------- Stagger indexes ---------------- */
  $$('[data-stagger]').forEach(function (p) {
    Array.prototype.slice.call(p.children).forEach(function (c, i) { c.style.setProperty('--i', i); });
  });
  $$('.benefits, .compare').forEach(function (p) {
    $$('li, .tick', p).forEach(function (c, i) { c.style.setProperty('--i', i); });
  });

  /* ---------------- Count up ---------------- */
  function countUp(el) {
    var to = parseFloat(el.getAttribute('data-count-to'));
    var dur = 1600, start = null;
    if (reduceMotion) { el.textContent = to.toLocaleString('en-US'); return; }
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var e = 1 - Math.pow(1 - p, 4);
      el.textContent = Math.round(to * e).toLocaleString('en-US');
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* ---------------- Reveal observer ---------------- */
  var revealTargets = $$('[data-reveal], [data-split], .benefits, .compare, [data-count-to]');
  if ('IntersectionObserver' in window && !reduceMotion) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var t = en.target;
        t.classList.add('is-in');
        if (t.hasAttribute('data-count-to')) countUp(t);
        io.unobserve(t);
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -6% 0px' });
    revealTargets.forEach(function (t) { io.observe(t); });
  } else {
    revealTargets.forEach(function (t) { t.classList.add('is-in'); if (t.hasAttribute('data-count-to')) t.textContent = parseFloat(t.getAttribute('data-count-to')).toLocaleString('en-US'); });
  }

  /* ---------------- Scroll-driven effects ---------------- */
  var parallaxEls = $$('[data-parallax]');
  var marquees = $$('.marquee__inner');
  var how = $('[data-how]');
  var howSteps = how ? $$('.how__step', how) : [];
  var howNum = how ? $('[data-how-num]', how) : null;
  var velocity = 0, prevY = window.scrollY, ticking = false;

  function onScroll() {
    onScrollHeader();
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var y = window.scrollY, vh = window.innerHeight;
      velocity = velocity * 0.8 + (y - prevY) * 0.2;
      prevY = y;
      if (!reduceMotion) {
        parallaxEls.forEach(function (el) {
          var r = el.getBoundingClientRect();
          var speed = parseFloat(el.getAttribute('data-parallax')) || 0.15;
          var offset = (r.top + r.height / 2 - vh / 2) * -speed;
          el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
        });
        var skew = Math.max(-8, Math.min(8, velocity * 0.25));
        marquees.forEach(function (m) { m.style.setProperty('--skew', skew.toFixed(2) + 'deg'); });
      }
      if (how && window.innerWidth > 900) {
        var scroller = $('.how__scroller', how);
        var rr = scroller.getBoundingClientRect();
        var total = rr.height - vh;
        var p = Math.max(0, Math.min(1, -rr.top / total));
        how.style.setProperty('--p', p.toFixed(4));
        var idx = Math.min(howSteps.length - 1, Math.floor(p * howSteps.length * 0.999));
        howSteps.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
        if (howNum && howNum.textContent !== String(idx + 1)) {
          howNum.style.transform = 'translateY(-10px) scale(.6)'; howNum.style.opacity = '0';
          setTimeout(function () { howNum.textContent = String(idx + 1); howNum.style.transform = ''; howNum.style.opacity = ''; }, 160);
        }
        var spiral = $('[data-spiral]', how);
        if (spiral) { var len = spiral.getTotalLength(); spiral.style.strokeDasharray = len; spiral.style.strokeDashoffset = (len * (1 - p)).toFixed(1); }
      }
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  // settle marquee skew back to 0
  setInterval(function () { if (Math.abs(velocity) > 0.05) { velocity *= 0.6; marquees.forEach(function (m) { m.style.setProperty('--skew', Math.max(-8, Math.min(8, velocity * 0.25)).toFixed(2) + 'deg'); }); } }, 120);
  onScroll();

  /* ---------------- Hero pointer glow ---------------- */
  $$('[data-hero]').forEach(function (hero) {
    if (reduceMotion || window.matchMedia('(hover: none)').matches) return;
    var glow = $('.hero__glow', hero);
    var visual = $('.hero__product', hero);
    hero.addEventListener('pointermove', function (e) {
      var r = hero.getBoundingClientRect();
      var x = e.clientX - r.left, y = e.clientY - r.top;
      if (glow) { glow.style.setProperty('--mx', x + 'px'); glow.style.setProperty('--my', y + 'px'); }
      if (visual) {
        var rx = (x / r.width - 0.5) * 14, ry = (y / r.height - 0.5) * -14;
        visual.style.translate = (rx).toFixed(1) + 'px ' + (-ry).toFixed(1) + 'px';
      }
    });
  });

  /* ---------------- Feature spotlight + tilt ---------------- */
  $$('.feature').forEach(function (card) {
    if (reduceMotion || window.matchMedia('(hover: none)').matches) return;
    card.addEventListener('pointermove', function (e) {
      var r = card.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
      card.style.setProperty('--fx', (x * 100) + '%'); card.style.setProperty('--fy', (y * 100) + '%');
      card.style.transform = 'perspective(800px) rotateX(' + ((0.5 - y) * 8).toFixed(2) + 'deg) rotateY(' + ((x - 0.5) * 8).toFixed(2) + 'deg) translateY(-4px)';
    });
    card.addEventListener('pointerleave', function () { card.style.transform = ''; });
  });

  /* ---------------- Magnetic buttons + ripple ---------------- */
  $$('[data-magnetic]').forEach(function (b) {
    if (reduceMotion || window.matchMedia('(hover: none)').matches) return;
    b.addEventListener('pointermove', function (e) {
      var r = b.getBoundingClientRect();
      var x = e.clientX - r.left - r.width / 2, y = e.clientY - r.top - r.height / 2;
      b.style.transform = 'translate(' + (x * 0.18).toFixed(1) + 'px,' + (y * 0.28).toFixed(1) + 'px)';
    });
    b.addEventListener('pointerleave', function () { b.style.transform = ''; });
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.btn');
    if (!b || reduceMotion) return;
    var r = b.getBoundingClientRect();
    var s = document.createElement('span');
    var size = Math.max(r.width, r.height);
    s.className = 'ripple';
    s.style.width = s.style.height = size + 'px';
    s.style.left = (e.clientX - r.left - size / 2) + 'px';
    s.style.top = (e.clientY - r.top - size / 2) + 'px';
    b.appendChild(s);
    setTimeout(function () { s.remove(); }, 700);
  });

  function sparkleBurst(x, y) {
    if (reduceMotion) return;
    var colors = ['#e0577d', '#f4bcc4', '#c9a46a', '#b06ad9', '#ffd9c2'];
    for (var i = 0; i < 22; i++) {
      var s = document.createElement('span');
      s.className = 'sparkle';
      var a = Math.random() * Math.PI * 2, d = 50 + Math.random() * 90;
      s.style.left = x + 'px'; s.style.top = y + 'px';
      s.style.background = colors[i % colors.length];
      s.style.setProperty('--dx', Math.cos(a) * d + 'px');
      s.style.setProperty('--dy', Math.sin(a) * d - 30 + 'px');
      s.style.setProperty('--r', (Math.random() * 540 - 270) + 'deg');
      if (i % 3 === 0) s.style.borderRadius = '50%';
      document.body.appendChild(s);
      setTimeout((function (n) { return function () { n.remove(); }; })(s), 950);
    }
  }

  /* ---------------- Accordion animation ---------------- */
  $$('.accordion details').forEach(function (d) {
    var summary = $('summary', d), body = $('.accordion__body', d);
    if (!summary || !body) return;
    summary.addEventListener('click', function (e) {
      if (reduceMotion) return;
      e.preventDefault();
      if (d.open) {
        body.style.height = body.scrollHeight + 'px';
        requestAnimationFrame(function () {
          body.style.transition = 'height .45s cubic-bezier(.16,1,.3,1)';
          body.style.height = '0px';
        });
        setTimeout(function () { d.open = false; body.style.height = ''; body.style.transition = ''; }, 450);
      } else {
        d.open = true;
        var h = body.scrollHeight;
        body.style.height = '0px';
        requestAnimationFrame(function () {
          body.style.transition = 'height .5s cubic-bezier(.16,1,.3,1)';
          body.style.height = h + 'px';
        });
        setTimeout(function () { body.style.height = ''; body.style.transition = ''; }, 520);
      }
    });
  });

  /* ---------------- Gallery ---------------- */
  $$('[data-gallery]').forEach(function (g) {
    var slides = $$('.gallery__slide', g), thumbs = $$('.gallery__thumb', g), dots = $$('.gallery__dots button', g);
    var main = $('.gallery__main', g);
    var cur = 0;
    function go(i) {
      if (!slides.length) return;
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === cur); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === cur); });
      dots.forEach(function (t, k) { t.classList.toggle('is-active', k === cur); });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    dots.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var prev = $('[data-prev]', g), next = $('[data-next]', g);
    if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); go(cur - 1); });
    if (next) next.addEventListener('click', function (e) { e.stopPropagation(); go(cur + 1); });
    if (main) {
      main.addEventListener('click', function (e) {
        if (e.target.closest('.gallery__nav')) return;
        if (window.matchMedia('(hover: none)').matches) return;
        main.classList.toggle('is-zoom');
      });
      main.addEventListener('pointermove', function (e) {
        var r = main.getBoundingClientRect();
        main.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%');
        main.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%');
        $$('img', main).forEach(function (img) { img.style.setProperty('--zx', main.style.getPropertyValue('--zx')); img.style.setProperty('--zy', main.style.getPropertyValue('--zy')); });
      });
      main.addEventListener('pointerleave', function () { main.classList.remove('is-zoom'); });
      var sx = null;
      main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1));
        sx = null;
      });
    }
    // autoplay gently until user interacts
    var auto = slides.length > 1 && !reduceMotion ? setInterval(function () { if (!main.matches(':hover')) go(cur + 1); }, 5200) : null;
    g.addEventListener('pointerdown', function () { if (auto) { clearInterval(auto); auto = null; } });
  });

  /* ---------------- Quantity ---------------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var wrap = b.closest('.qty'); var input = $('input', wrap);
    var v = parseInt(input.value, 10) || 1;
    v = b.getAttribute('data-qty') === 'plus' ? v + 1 : Math.max(parseInt(input.min || '1', 10), v - 1);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------- Delivery estimate ---------------- */
  $$('[data-delivery]').forEach(function (el) {
    var min = parseInt(el.getAttribute('data-min') || '4', 10), max = parseInt(el.getAttribute('data-max') || '6', 10);
    function addBiz(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; }
    var o = { month: 'short', day: 'numeric' };
    var now = new Date();
    el.textContent = addBiz(now, min).toLocaleDateString('en-US', o) + ' – ' + addBiz(now, max).toLocaleDateString('en-US', o);
  });

  /* ---------------- Cart ---------------- */
  var drawer = $('[data-drawer]');
  function openDrawer() {
    if (!drawer) { window.location.href = routes.cart_url; return; }
    drawer.classList.add('is-open');
    document.documentElement.classList.add('drawer-open');
    document.body.style.overflow = 'hidden';
    var close = $('[data-drawer-close]', drawer); if (close) setTimeout(function () { close.focus(); }, 300);
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('drawer-open');
    document.body.style.overflow = '';
  }
  $$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); if (menu) menu.classList.remove('is-open'); } });
  $$('[data-cart-open]').forEach(function (a) { a.addEventListener('click', function (e) { if (!drawer) return; e.preventDefault(); refreshCart().then(openDrawer); }); });

  function imgUrl(src, w) {
    if (!src) return '';
    try { var u = new URL(src, window.location.origin); u.searchParams.set('width', w); return u.toString(); } catch (e) { return src; }
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (el) {
      var before = el.textContent;
      el.textContent = cart.item_count;
      el.classList.toggle('has-items', cart.item_count > 0);
      if (String(before) !== String(cart.item_count)) { el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); }
    });
    if (!drawer) return;
    var body = $('[data-drawer-body]', drawer), foot = $('[data-drawer-foot]', drawer);
    if (!cart.item_count) {
      body.innerHTML = '<div class="drawer__empty">' + (C.spiralSvg || '') + '<h3>Your bag is empty</h3><p style="color:var(--muted)">Your next great hair day is one click away.</p><a href="' + esc(C.productUrl || routes.root) + '" class="btn btn--rose" style="margin-top:10px">Shop Curlora</a></div>';
      foot.hidden = true;
      return;
    }
    foot.hidden = false;
    body.innerHTML = cart.items.map(function (it, i) {
      return '<div class="line" style="--i:' + i + '" data-key="' + esc(it.key) + '">' +
        '<a class="line__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(imgUrl(it.image, 200)) + '" alt="' + esc(it.product_title) + '" width="84" height="84" loading="lazy">' : '') + '</a>' +
        '<div><div class="line__title">' + esc(it.product_title) + '</div>' +
        (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="line__meta">' + esc(it.variant_title) + '</div>' : '') +
        '<div class="line__bottom"><div><div class="qty"><button type="button" data-line-qty="minus" aria-label="Decrease quantity">−</button><input type="number" min="0" value="' + it.quantity + '" aria-label="Quantity" readonly><button type="button" data-line-qty="plus" aria-label="Increase quantity">+</button></div><button type="button" class="line__remove" data-line-remove>Remove</button></div>' +
        '<strong>' + formatMoney(it.final_line_price) + '</strong></div></div></div>';
    }).join('');
    $('[data-drawer-total]', drawer).textContent = formatMoney(cart.total_price);
  }

  function refreshCart() {
    return fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; })
      .catch(function () {});
  }

  function changeLine(key, qty) {
    return fetch(routes.cart_change_url + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var line = e.target.closest('.line'); if (!line) return;
      var key = line.getAttribute('data-key');
      var q = parseInt($('input', line).value, 10) || 0;
      if (e.target.closest('[data-line-qty="plus"]')) changeLine(key, q + 1);
      else if (e.target.closest('[data-line-qty="minus"]')) changeLine(key, Math.max(0, q - 1));
      else if (e.target.closest('[data-line-remove]')) { line.style.transition = 'opacity .3s, transform .3s'; line.style.opacity = '0'; line.style.transform = 'translateX(30px)'; setTimeout(function () { changeLine(key, 0); }, 250); }
    });
  }

  $$('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = $('[type="submit"]', form) || $('button', form);
      var label = btn ? $('.btn__label', btn) : null;
      var original = label ? label.textContent : '';
      if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
      var fd = new FormData(form);
      fetch(routes.cart_add_url + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          if (btn) {
            var r = btn.getBoundingClientRect();
            sparkleBurst(r.left + r.width / 2, r.top + r.height / 2);
            btn.classList.remove('is-loading'); btn.classList.add('is-added');
            if (label) label.textContent = 'Added to bag ✓';
          }
          return refreshCart().then(function () { setTimeout(openDrawer, reduceMotion ? 0 : 450); });
        })
        .catch(function (err) {
          if (btn) btn.classList.remove('is-loading');
          var msg = (err && (err.description || err.message)) || 'Something went wrong. Please try again.';
          var box = $('[data-form-error]', form);
          if (box) { box.textContent = msg; box.hidden = false; } else { alert(msg); }
        })
        .finally(function () {
          setTimeout(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-added'); if (label) label.textContent = original; } }, 2200);
        });
    });
  });

  // keep the sticky bar quantity in sync & submit main form
  $$('[data-sticky-submit]').forEach(function (b) {
    b.addEventListener('click', function () {
      var form = $('form[data-product-form]');
      if (form) { if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true })); }
    });
  });

  /* ---------------- Sticky add to cart ---------------- */
  var sticky = $('[data-sticky-atc]');
  var mainBtn = $('[data-main-atc]');
  if (sticky && mainBtn) {
    var footerEl = $('.site-footer');
    var stickyTick = false;
    var updSticky = function () {
      stickyTick = false;
      var past = mainBtn.getBoundingClientRect().bottom < 0;
      var nearFooter = footerEl ? footerEl.getBoundingClientRect().top < window.innerHeight : false;
      sticky.classList.toggle('is-visible', past && !nearFooter);
    };
    window.addEventListener('scroll', function () { if (!stickyTick) { stickyTick = true; requestAnimationFrame(updSticky); } }, { passive: true });
    updSticky();
  }

  /* ---------------- Variant select (multi-variant safety) ---------------- */
  $$('[data-variant-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var form = sel.closest('form'); var opt = sel.options[sel.selectedIndex];
      var price = opt.getAttribute('data-price');
      $$('[data-price-now]').forEach(function (p) { if (price) p.textContent = formatMoney(parseInt(price, 10)); });
      var btn = form && $('[type="submit"]', form);
      if (btn) btn.disabled = opt.hasAttribute('data-unavailable');
    });
  });

  refreshCart();
  document.documentElement.classList.add('is-ready');
})();
